import { defineMessages } from 'react-intl';

export default defineMessages({
  modelNotReturnable: {
    id: 'view.card.products.notOpenForClaimsReason.modelNotReturnable',
    defaultMessage: 'Model not returnable',
  },
  modelTypeNotReturnable: {
    id: 'view.card.products.notOpenForClaimsReason.modelTypeNotReturnable',
    defaultMessage: 'Model type not returnable',
  },
  sample: {
    id: 'view.card.products.notOpenForClaimsReason.sample',
    defaultMessage: 'Sample',
  },
  swapped: {
    id: 'view.card.products.notOpenForClaimsReason.swapped',
    defaultMessage: 'Swapped',
  },
  refunded: {
    id: 'view.card.products.notOpenForClaimsReason.refunded',
    defaultMessage: 'Refunded',
  },
  ownerChanged: {
    id: 'view.card.products.notOpenForClaimsReason.ownerChanged',
    defaultMessage: 'Owner changed',
  },
  serviceBlockingReturn: {
    id: 'view.card.products.notOpenForClaimsReason.serviceBlockingReturn',
    defaultMessage: 'Service blocking return',
  },
});
